import { render } from "./VirtualRedTagInvalidQr.vue?vue&type=template&id=1d6dce3a&scoped=true&ts=true"
import script from "./VirtualRedTagInvalidQr.vue?vue&type=script&lang=ts"
export * from "./VirtualRedTagInvalidQr.vue?vue&type=script&lang=ts"

import "./VirtualRedTagInvalidQr.vue?vue&type=style&index=0&id=1d6dce3a&lang=scss&scoped=true"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d6dce3a"]])

export default __exports__